import '../styles/LeadsOpener.css';
import React from 'react';

function RuleMark() {
  return (
    <span className="lo-mark" aria-hidden="true">
      <svg viewBox="0 0 24 12" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round">
        <path d="M0.5 8.4 C3.2 5.2 5.6 9.1 8.4 6.6 C11.1 4.2 13.4 7.6 16 5.4 C18.4 3.4 21 5.8 23.5 3.2" />
        <path d="M4 11 C7 9.6 10 10.4 13 9.4 C16 8.4 19 9.6 22 8.6" opacity="0.45" />
      </svg>
    </span>
  );
}

function LeadsOpener() {
  return (
    <section className="lo-opener" aria-labelledby="lo-heading">
      <div className="lo-read" data-content-rail="reading">
        <p className="lo-eyebrow">
          <RuleMark />
          <span className="lo-label">Lead list</span>
        </p>

        <h1 id="lo-heading" className="lo-heading">
          Extracted leads
        </h1>

        <hr className="lo-rule" />

        <p className="lo-statement">
          Every email dbaseextractor pulled from your crawls lands here. Each lead
          shows its email address, the source page it was found on, and the crawl
          it belongs to, so you can trace it back to the web page or directory it
          came from.
        </p>

        <a className="lo-return" href="/crawls">
          <span>Return to Crawls</span>
          <span className="lo-arrow" aria-hidden="true">
            <svg viewBox="0 0 18 12" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M11.5 1.5 L17 6 L11.5 10.5" />
              <path d="M17 6 L1 6" />
            </svg>
          </span>
        </a>
      </div>
    </section>
  );
}

export default LeadsOpener;